export const screencastEn = {
  buttonHint: 'Record screen and send to the chat',
  stop: 'Stop recording',
  pause: 'Pause',
  resume: 'Resume',
  discardVideo: 'Discard this video',
  sendToChat: 'Send to chat',
  messageWhenUploaded: (task: string) =>
    `Video successfully uploaded to task "${task}"`,
  messageWhenUploaded2: `Video successfully uploaded`,
  closeConfirm: 'Are you sure you want to discard this video?',
  alreadyRecording: 'Screen recording is already started',
  tooLargeFileToUpload: (fileSizeMb: number, fileLimitMb: number) =>
    `This recording has size of ${fileSizeMb}Mb which is larger than ${fileLimitMb}Mb limit, so it can't be sent to chat. You can download this file and use some file sharing service to post a link to this file into chat`,
  noMic: 'no sound',
  noMicHint: 'Failed to get permissions to use microphone',
  uploadFailedTitle: 'Video upload failed',
  uploadFailedMessage: 'Failed to upload the video. Retry or cancel sending?',
  uploadFailedRetry: 'Retry',
  uploadFailedCancel: 'Cancel'
}

export const screencastRu: typeof screencastEn = {
  buttonHint: 'Записать видео экрана и отправить в чат',
  stop: 'Остановить запись',
  pause: 'Пауза',
  resume: 'Продолжить',
  discardVideo: 'Удалить это видео',
  sendToChat: 'Отправить в чат',
  messageWhenUploaded: (task: string) =>
    `Видео успешно загружено в задачу "${task}"`,
  messageWhenUploaded2: `Видео успешно загружено`,
  closeConfirm: 'Вы уверены, что хотите отказаться отправлять это видео?',
  alreadyRecording: 'Запись экрана уже запущена',
  tooLargeFileToUpload: (fileSizeMb: number, fileLimitMb: number) =>
    `Размер этой записи ${fileSizeMb}Мб, это больше, чем лимит ${fileLimitMb}Мб, поэтому её нельзя отправить в чат. Вы можете скачать этот файл, загрузить его в файлообменный сервис и отправить в чат ссылку на него`,
  noMic: 'без звука',
  noMicHint:
    'Звук не записывается, так как не удалось получить разрешение на доступ к микрофону',
  uploadFailedTitle: 'Ошибка загрузки видео',
  uploadFailedMessage:
    'Не удалось загрузить видео. Повторить попытку или отменить отправку?',
  uploadFailedRetry: 'Повторить',
  uploadFailedCancel: 'Отменить'
}
